/* istanbul ignore file */
/* eslint-disable max-len */
import { logError } from '../utils';

export const nullLocation = { latitude: null, longitude: null };

export const isNullLocation = ({ latitude, longitude }) => (
  (latitude === null && longitude === null) || (latitude === undefined && longitude === undefined)
);

export const isNullAddress = ({ latitude, longitude, address }) => (
  // (latitude === null && longitude === null && address === null)
  // || (latitude === undefined && longitude === undefined && address === undefined)
  // || (latitude === 0 && longitude === 0 && address === '')
  (!latitude && !longitude && !address)
);

export const getZipCodeFromGeoData = address => {
  const { data = [] } = address;
  const { address_components = {} } = data[0];
  const filteredComponent = address_components.filter(addressComponent => addressComponent.types.indexOf('postal_code') >= 0)[0];
  return filteredComponent ? filteredComponent.long_name : '';
};

export const getAddressFromGeoData = address => {
  const { data = [] } = address;
  const { formatted_address = '' } = data[0];
  return formatted_address;
};

export const getStateFromGeoData = address => {
  const { data = [] } = address;
  const { address_components = {} } = data[0];
  const filteredComponent = address_components.filter(addressComponent => addressComponent.types.indexOf('administrative_area_level_1') >= 0)[0];
  return filteredComponent ? filteredComponent.long_name : '';
};

export const getCityFromGeoData = address => {
  const { data = [] } = address;
  const { address_components = {} } = data[0];
  const filteredComponent = address_components.filter(addressComponent => addressComponent.types.indexOf('administrative_area_level_2') >= 0)[0];
  return filteredComponent ? filteredComponent.long_name : '';
};

export const getDistrictFromGeoData = address => {
  const { data = [] } = address;
  const { address_components = {} } = data[0];
  const filteredComponent = address_components.filter(addressComponent => addressComponent.types.indexOf('locality') >= 0)[0];
  return filteredComponent ? filteredComponent.long_name : '';
};

export const getStreetFromGeoData = address => {
  const { data = [] } = address;
  const { address_components = {} } = data[0];
  const filteredComponent = address_components.filter(addressComponent => addressComponent.types.indexOf('route') >= 0)[0];
  return filteredComponent ? filteredComponent.long_name : '';
};

const reverseGeoCode = (latitude, longitude) => {
  const lat = latitude;
  const lng = longitude;
  const latlng = new window.google.maps.LatLng(lat, lng);
  const geocoder = new window.google.maps.Geocoder();
  return new Promise((resolve, reject) => {
    geocoder.geocode({ location: latlng }, (results, status) => {
      if (status !== window.google.maps.GeocoderStatus.OK) {
        reject(status);
      } else {
        resolve({ data: results, lat, lng });
      }
    });
  });
};

export const getAddressComponentFromLatLong = async (latitude, longitude) => {
  try {
    const address = await reverseGeoCode(latitude, longitude);
    return {
      add: getAddressFromGeoData(address),
      latitude,
      longitude,
      pincode: getZipCodeFromGeoData(address),
      city: getCityFromGeoData(address),
      state: getStateFromGeoData(address),
      street: getStreetFromGeoData(address),
      district: getDistrictFromGeoData(address)
    };
  } catch (e) {
    logError(e);
    return {
      latitude, longitude
    };
  }
};

const transformPincodeResponseData = results => {
  const resp = results[0] && results[0].address_components;
  const cityResp = resp.find(loc => loc.types.includes('locality')) || resp.find(loc => loc.types.includes('administrative_area_level_2'));
  const stateResp = resp.find(loc => loc.types.includes('administrative_area_level_1'));
  const lat = results[0].geometry.location.lat();
  const lng = results[0].geometry.location.lng();
  return {
    state: stateResp && stateResp.long_name ? stateResp.long_name : '',
    city: cityResp && cityResp.long_name ? cityResp.long_name : '',
    latitude: lat,
    longitude: lng
  };
};

export const getLocationFromPincode = pincode => {
  const geocoder = new window.google.maps.Geocoder();
  return new Promise((resolve, reject) => {
    geocoder.geocode({ address: pincode, region: 'in' }, (results, status) => {
      if (status !== window.google.maps.GeocoderStatus.OK) {
        reject(status);
      } else {
        resolve(transformPincodeResponseData(results));
      }
    });
  });
};
